/**
 * @param   {EditorState} editorState
 * @returns {Boolean}
 */
export default function getCurrentEntity(editorState) {
  const contentState = editorState.getCurrentContent();
  const currentSelection = editorState.getSelection();
  const anchorKey = currentSelection.getAnchorKey();
  const anchorBlock = contentState.getBlockForKey(anchorKey);

  const entityKey = anchorBlock.getEntityAt(
    currentSelection.isBackward ? currentSelection.anchorOffset - 1 : currentSelection.anchorOffset
  );

  if (entityKey) {
    return contentState.getEntity(entityKey);
  }

  return null;
}
